// PrefilledTable.jsx
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Modal } from 'react-bootstrap';
import { tableColumns } from './PrefilledData';
import axios from 'axios';
import { ServerPath } from '../../Constant';

const PrefilledTable = ({ show, handleClose }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (show) {
            fetchHistoryData();
        }
    }, [show]);

    const fetchHistoryData = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await axios.get(`${ServerPath}/prefilled-details/history`);
            
            if (response.data.success === 1) {
                const sortedHistory = response.data.data.sort((a, b) => b.history_id - a.history_id);
                
                const transformedData = sortedHistory.map((item, index) => {
                    let newAmount;
                    if (index === 0) {
                        // For most recent change, use the current_amount
                        newAmount = item.current_amount;
                    } else {
                        // For all other records, use the previous record's previous_prefilled_amount
                        newAmount = sortedHistory[index - 1].previous_prefilled_amount;
                    }
    
                    return {
                        id: item.history_id,
                        previous_amount: item.previous_prefilled_amount,
                        new_amount: newAmount,
                        modified_by: item.changed_by,
                        modified_date: new Date(item.changed_on).toLocaleDateString('en-GB')
                    };
                });
                
                console.log('Transformed Data:', transformedData); // For debugging
                setData(transformedData);
            } else {
                setError('Failed to fetch data');
            }
        } catch (error) {
            console.error('Error fetching history:', error);
            setError(error.response?.data?.message || 'Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };
    const customStyles = {
        rows: {
            style: {
                minHeight: '52px',
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                backgroundColor: 'white',
                color: '#6B7280',
                fontSize: '0.875rem'
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
            },
        },
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            size="lg"
            dialogClassName="modal-90w"
            style={{ minWidth: '80vw' }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Others (Amount)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <DataTable
                    columns={tableColumns}
                    data={data}
                    customStyles={customStyles}
                    pagination
                    responsive
                    highlightOnHover
                    striped
                    progressPending={loading}
                    progressComponent={
                        <div className="d-flex justify-content-center py-3">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                />
            </Modal.Body>
        </Modal>
    );
};

export default PrefilledTable;